import { render, staticRenderFns } from "./ComplianceForm.vue?vue&type=template&id=3c9f8c28&"
import script from "./ComplianceForm.vue?vue&type=script&lang=js&"
export * from "./ComplianceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports